<template>
	<fieldset :disabled="loading > 0">
		<div class="d-flex flex-wrap align-items-center" style="gap: 0.5rem 1rem">
			<b-form-checkbox switch v-model="enableTTS" @change="saveField('enableTTS', enableTTS, 'TTS')">TTS</b-form-checkbox>
			<b-form-checkbox switch v-model="enableEventSounds" @change="saveField('enableEventSounds', enableEventSounds, 'Event sounds')">Sounds</b-form-checkbox>
			<b-icon v-show="saving > 0" icon="circle-fill" animation="throb" class="ml-auto"></b-icon>
		</div>
		<volume-slider v-model="volume" class="mt-3" @change="saveField('volume', volume, 'Volume')" />
	</fieldset>
</template>

<script>
import VolumeSlider from '@/components/VolumeSlider.vue';

export default {
	components: { VolumeSlider },
	data() { return {
		loading: 0,
		saving: 0,
		enableTTS: false,
		enableEventSounds: false,
		volume: 100,
		subId: null,
	}},
	watch: {
		loading(val) { this.$emit('loading', val > 0); },
	},
	mounted() {
		this.loadSettings();
	},
	beforeDestroy() {
		this.subId && this.$socket.unsubscribe(this.subId);
	},
	methods: {
		async loadSettings() {
			this.loading++;
			try {
				const [user, settings] = await Promise.all([
					this.$api.get('userData'),
					this.$api.get('widgetSettings/chat'),
				]);
				this.enableTTS = Boolean(settings?.enableTTS);
				this.enableEventSounds = Boolean(settings?.enableEventSounds);
				this.volume = settings?.volume ?? 100;
				this.subId = this.$socket.subscribe(user?.widget_hash, {
					widgetSettingsFieldChange: msg => {
						if(msg.widgetType != 'chat') return;
						if(msg.field == 'enableTTS') this.enableTTS = Boolean(msg.value);
						if(msg.field == 'enableEventSounds') this.enableEventSounds = Boolean(msg.value);
						if(msg.field == 'volume') this.volume = msg.value;
					},
				});
			} catch(e) {
				console.error('loading', e);
				this.$bvToast.toast(`Could not load chat widget settings: ${e.error||e.toString()}`, { title: 'Error', variant: 'danger', solid: true });
			} finally {
				this.loading--;
			}
		},
		async saveField(field, value, name) {
			try {
				this.saving++;
				await this.$api.post(`widgetSettings/chat/${encodeURIComponent(field)}`, { value });
			} catch(e) {
				console.error('saving', e);
				this.$bvToast.toast(`Could not ${value === true ? 'enable' : (value === false ? 'disable' : 'update')} ${name}: ${e.error||String(e)}`, { title: 'Error', variant: 'danger', solid: true });
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
